function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var r = Object.defineProperty;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty,
    p = Object.prototype.propertyIsEnumerable;

var n = function n(o, e, l) {
  return e in o ? r(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: l
  }) : o[e] = l;
},
    C = function C(o, e) {
  for (var l in e || (e = {})) {
    d.call(e, l) && n(o, l, e[l]);
  }

  if (t) {
    var _iterator = _createForOfIteratorHelper(t(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        p.call(e, l) && n(o, l, e[l]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as i from "react";

function w(o) {
  return i.createElement("svg", C({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.66667H16.59C17.48 9.66667 17.92 10.5867 17.29 11.1233L12.7 15.0333C12.31 15.3656 11.68 15.3656 11.29 15.0333L6.7 11.1233C6.07 10.5867 6.52 9.66667 7.41 9.66667H9V5.40741C9 4.93889 9.45 4.55556 10 4.55556H14C14.55 4.55556 15 4.93889 15 5.40741V9.66667ZM6 19.037C5.45 19.037 5 18.6537 5 18.1852C5 17.7167 5.45 17.3333 6 17.3333H18C18.55 17.3333 19 17.7167 19 18.1852C19 18.6537 18.55 19.037 18 19.037H6Z",
    fill: "black"
  }));
}

export { w as ReactComponent };